/**
 * Layout constants shared by the app chrome.
 *
 * The AppBar height was a bare `64` literal duplicated across TopBar, Layout
 * and Sidebar. Any right-hand Drawer that did not know about it rendered
 * underneath the fixed header and lost its title — which is exactly what
 * happened to the sequence drawer on the Marketing Overview.
 */

/** Fixed AppBar height in px (TopBar's Toolbar minHeight). */
export const APP_BAR_HEIGHT = 64;

/**
 * Paper styles for a right-anchored Drawer so it starts below the AppBar.
 *
 * Offsetting `top` rather than raising the drawer's z-index above the AppBar
 * is deliberate: the header stays visible and clickable while the drawer is
 * open, so an operator can navigate away without closing it first.
 */
export const rightDrawerBelowAppBarSx = {
  top: `${APP_BAR_HEIGHT}px`,
  height: `calc(100% - ${APP_BAR_HEIGHT}px)`,
} as const;
